var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2437 11.6918V3.18304C15.2437 2.65746 14.8157 2.22948 14.2883 2.22948H14.0105V1.95355C14.0105 1.42797 13.5825 1 13.055 1H1.48473C0.95727 1 0.529297 1.42797 0.529297 1.95355V16.7168C0.529297 17.2423 0.95727 17.6703 1.48473 17.6703H1.76254V17.9462C1.76254 18.4718 2.19051 18.8998 2.71797 18.8998H11.7749C12.6158 20.4653 14.2751 21.5333 16.1822 21.5333C18.9359 21.5333 21.1771 19.3052 21.1771 16.5647C21.1771 13.4732 18.3427 11.0968 15.2437 11.6862V11.6918ZM16.1822 20.974C14.1794 20.974 12.3887 19.6243 11.8837 17.6422C11.3882 15.675 12.3079 13.6609 14.0555 12.7073C17.0232 11.0912 20.614 13.2554 20.614 16.5703C20.614 18.9993 18.6262 20.9758 16.1822 20.9758V20.974ZM11.5139 18.3404H2.71797C2.5021 18.3404 2.32566 18.164 2.32566 17.95V3.18304C2.32566 2.96718 2.5021 2.79261 2.71797 2.79261H14.2883C14.5041 2.79261 14.6806 2.96905 14.6806 3.18304C14.6806 8.94817 14.6743 11.8332 14.6618 11.8382C11.9438 12.7054 10.4928 15.6844 11.5158 18.3404H11.5139ZM1.09054 16.7186V1.95355C1.09054 1.73769 1.26699 1.56312 1.48285 1.56312H13.0531C13.269 1.56312 13.4455 1.73957 13.4455 1.95355V2.22948H2.71797C2.19051 2.22948 1.76254 2.65746 1.76254 3.18304V17.1091H1.48473C1.26886 17.1091 1.09242 16.9326 1.09242 16.7186H1.09054Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.57237 9.24536C6.5949 9.26976 6.62117 9.28853 6.65121 9.30355C7.75681 10.1182 9.24533 10.1182 10.3509 9.30355C10.381 9.28853 10.4072 9.26788 10.4298 9.24536C12.7686 7.40582 11.4528 3.65918 8.50013 3.65918C5.54749 3.65918 4.23166 7.40582 6.57049 9.24536H6.57237ZM8.502 4.2223C10.7038 4.2223 11.892 6.84646 10.4091 8.49828C10.2458 7.98772 9.88729 7.56913 9.41989 7.32886C10.4166 6.47292 9.81033 4.83611 8.502 4.83611C7.19368 4.83611 6.58926 6.47292 7.58411 7.32886C7.1186 7.56913 6.7582 7.98772 6.5949 8.49828C5.11201 6.84646 6.29832 4.2223 8.502 4.2223ZM7.07543 8.91875C7.17304 8.20734 7.7737 7.67049 8.502 7.67049C9.23031 7.67049 9.83097 8.20734 9.92858 8.91875C9.06513 9.49876 7.937 9.49876 7.07355 8.91875H7.07543ZM7.65357 6.2533C7.65357 5.78215 8.03461 5.39923 8.50388 5.39923C8.97315 5.39923 9.3542 5.78215 9.3542 6.2533C9.3542 6.72445 8.97315 7.10737 8.50388 7.10737C8.03461 7.10737 7.65357 6.72445 7.65357 6.2533Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.52093 11.1906H13.4845C13.6327 11.1906 13.766 11.0667 13.766 10.909C13.766 10.7626 13.644 10.6274 13.4845 10.6274H3.52093C3.14927 10.6274 3.14927 11.1906 3.52093 11.1906Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4704 12.7589C11.842 12.7589 11.8458 12.1958 11.4553 12.1958H3.52093C3.14927 12.1958 3.14927 12.7589 3.52093 12.7589H11.4704Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.5036 13.7775C10.4266 13.7531 10.5017 13.7625 3.51898 13.7625C3.14732 13.7625 3.14732 14.3256 3.51898 14.3256H10.4172C10.7345 14.3256 10.8095 13.877 10.5036 13.7775Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.99872 15.3296H3.52093C3.14927 15.3296 3.14927 15.8927 3.52093 15.8927H9.99872C10.1583 15.8927 10.2803 15.7613 10.2803 15.6112C10.2803 15.461 10.1583 15.3296 9.99872 15.3296Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.99872 16.8975H3.52094C3.15115 16.8975 3.1474 17.4606 3.52094 17.4606H9.99872C10.1489 17.4606 10.2803 17.3348 10.2803 17.179C10.2803 17.0232 10.1583 16.8975 9.99872 16.8975Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.1545 14.1999L16.1835 16.1709L14.2126 14.1999C13.9498 13.9371 13.5519 14.3351 13.8147 14.5979L15.7856 16.5688L13.8147 18.5397C13.5519 18.8025 13.9498 19.2005 14.2126 18.9377L16.1835 16.9667L18.1545 18.9377C18.4173 19.2005 18.8152 18.8025 18.5524 18.5397L16.5815 16.5688L18.5524 14.5979C18.8152 14.3351 18.4173 13.9371 18.1545 14.1999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedIcon);
export default __webpack_public_path__ + "static/media/Closed_icon.8abb80169549feca1f7d5ba8adf01ba9.svg";
export { ForwardRef as ReactComponent };